import { MOBILE_STORES, TableTagNamespace } from 'src/shared/enums';

export type TableTag = {
    id: string;
    restaurantId: string;
    restaurantName: string;
    namespace: TableTagNamespace;
};

const tableTagToHumanId = (tableTagId: string, namespace: string) => {
    const humanIdArr = [
        '000000' + tableTagId.substr(-6),
    ];

    if (namespace !== TableTagNamespace.TABLE) {
        humanIdArr.push(` (${namespace})`);
    }

    return humanIdArr.join(' ');
};

/**
 * Create URL for redirect or execute android application.
 */
export const createUrlForAndroid = (tableTag?: TableTag) => {
    const storeWebUrl = new URL(MOBILE_STORES.android.web);
    const storeNativeUrl = new URL(MOBILE_STORES.android.native);
    const referrer: string[] = [];

    if (tableTag) {
        const restaurantToken = `[${((tableTag ? tableTag.restaurantId.substr(0, 8) : null) || '- null -')}] ${tableTag.restaurantName}`.trim();
        referrer.push(`utm_medium=${encodeURIComponent(restaurantToken)}`);
        referrer.push('utm_campaign=qr');
        referrer.push(`utm_source=${encodeURIComponent(tableTagToHumanId(tableTag.id, tableTag.namespace))}`);
    }

    if (referrer.length > 0) {
        const referrerString = referrer.join('&');
        storeWebUrl.searchParams.append('referrer', referrerString);
        storeNativeUrl.searchParams.append('referrer', referrerString);
    }

    const currentUrl = window?.location?.href;

    if (currentUrl !== undefined) {
        const originalUrl = new URL(currentUrl);
        const queryParams = new URLSearchParams(originalUrl.searchParams);

        originalUrl.host = 'qerko.com'; // App is not compatible with other hosts

        if (queryParams.has('use-market-scheme')) window.location.replace(`${MOBILE_STORES.android.nativeWithSchema}&id=com.itispaid&launch=true&originalUrl=${originalUrl.toString()}`);

        storeWebUrl.searchParams.append('originalUrl', originalUrl.toString());
        storeNativeUrl.searchParams.append('link', originalUrl.toString());
        originalUrl.searchParams.append('use-market-scheme', 'true');
        storeNativeUrl.searchParams.append('afl', originalUrl.toString());
    }

    return {
        storeUrl: storeNativeUrl.toString(),
        storeWebUrl: storeWebUrl.toString(),
    };
};

/**
 * Create URL for redirect or execute ios application.
 */
export const createUrlForIos = (tableTag?: TableTag) => {
    const storeUrl = new URL(MOBILE_STORES.ios.native);

    if (tableTag) {
        storeUrl.searchParams.append('ct', tableTagToHumanId(tableTag.id, tableTag.namespace)); // campaign token
    }

    return {
        storeUrl: storeUrl.toString(),
        storeWebUrl: storeUrl.toString(),
    };
};
